export default __webpack_public_path__ + "static/media/simplified-bg.3762f821.svg";